import user from '../api/user'

// 接口文件
export default {
  ...user,
};
